/*
* todo 时间格式化
* */
import LocalStorage from './localStorage.js'

export default {
  utc2beijing(utc_datetime) {
    var date = new Date(utc_datetime)
    var formatDate = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate() + ' '
      + (date.getHours() > 9 ? date.getHours() : "0" + date.getHours())
      + ':' + (date.getMinutes() > 9 ? date.getMinutes() : "0" + date.getMinutes())
      + ':' + (date.getSeconds() > 9 ? date.getSeconds() : "0" + date.getSeconds());
    return formatDate
  },
  timeFormat: (value, f) => {
    if (!f) f = 'yyyy-MM-dd'
    if (!value) return ''
    var elem = new Date(value)
    var o = {
      'M+': elem.getMonth() + 1, // 月
      'd+': elem.getDate(), // d日
      'h+': elem.getHours(), // 时
      'm+': elem.getMinutes(), // 分
      's+': elem.getSeconds(), // 秒
      'q+': Math.floor((elem.getMonth() + 3) / 3),
      'S': elem.getMilliseconds()
    }
    if (/(y+)/.test(f)) f = f.replace(RegExp.$1, (elem.getFullYear() + '').substr(4 - RegExp.$1.length))
    for (var k in o) {
      if (new RegExp('(' + k + ')').test(f)) f = f.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length))
    }
    return f
  },
  // 货币对 添加 斜杠符号/
  cpFormat: (str) => {
    if (!str) return ''
    if (str.indexOf('/') === -1) {
      let newStr = str.slice(0, 3) + '/' + str.slice(3)
      return newStr
    }
  }, // 货币对 去掉 斜杠符号/
  searchCp: (str) => {
    if (!str) return ''
    var reg2 = new RegExp(' ', 'g')
    var nStr = str.replace(reg2, '')
    var newStr = nStr
    if (str.indexOf('/') !== -1) {
      var reg1 = new RegExp('/', 'g')
      newStr = nStr.replace(reg1, '')
    }
    return newStr
  },
  // 公共参数 key-value
  getCommonName: (key) => {
    let commonJson = {
      // 中国银行香港
      'MaxAccumulatedAmountForOneDay': '单日交易累计金额上限(USD)',
      // 公共
      'MinAmountForSingleTransaction': '交易单笔最小金额(USD)',
      'MaxAmountForSingleTransaction': '交易单笔最大金额(USD)',
      'RealtimeExchangeChannel': '实时换汇交易主用渠道',
      'LockingExchangeRateTimeForCustomer': '对客交易汇率锁汇时长(秒)',
      'ManualExchangePassword': '手工换汇密码',
      'RealtimeExchangeTradingTypeInNonBankTradingTime': '非银行交易时间下的实时换汇交易方式',
      'RealtimeExchangeRateCrawlingUpdateAllowableFloatTolerance': '实时抓取时校验的浮动容差值'
    }
    if (commonJson.hasOwnProperty(key)) {
      return commonJson[key]
    } else {
      return ''
    }
  },
  Export(data, fileName) { // 文件流下载
    const blob = new Blob([data])
    if ('download' in document.createElement('a')) { // 非IE下载
      const elink = document.createElement('a')
      elink.download = fileName
      elink.style.display = 'none'
      elink.href = URL.createObjectURL(blob)
      document.body.appendChild(elink)
      elink.click()
      URL.revokeObjectURL(elink.href) // 释放URL 对象
      document.body.removeChild(elink)
    } else { // IE10+下载
      navigator.msSaveBlob(blob, fileName)
    }
  },

  formatCurrencyCode(code) { // 获取货币中文名称
    let name = ''
    let currencys = LocalStorage.get('currencys')
    currencys.map(function (item) {
      if (code === item.Value) {
        name = item.Description
      }
    })
    return name
  },

  formatCurrencyPairs(outBill, inBill) { // 匹配正确的货币对
    let pairs1 = outBill + inBill
    let pairs2 = inBill + outBill
    let name = ''
    let currencyPairs = LocalStorage.get('currencyPairs')
    currencyPairs.map(function (item) {
      if (pairs1 === item.Value) {
        name = pairs1
      } else if (pairs2 === item.Value) {
        name = pairs2
      }
    })
    return name
  },
  reviewStatusFormat(key) { // 换汇单审核 状态
    let statusJson = {
      'WaitForPreliminaryApprove': '待初审',
      'PreliminaryApproving': '初审中',
      'PreliminaryApproved': '已初审',
      'WaitForSecondApprove': '待复审',
      'SecondApproving': '复审中',
      'SecondApproved': '复审通过',
      'SecondApprovedReject': '复审不通过'
    }
    if (statusJson.hasOwnProperty(key)) {
      return statusJson[key]
    } else {
      return ''
    }
  },
  OrderStatusFormat(key) { // 运单状态
    let statusJson = {
      'Pending': '等待查询',
      'NotFound': '查询不到',
      'InfoReceived': '预报发货',
      'InTransit': '运输途中',
      'ArrivedDelivery': '到达待取',
      'Delivering': '派送途中',
      'Delivered': '成功派送',
      'DeliveryFailure': '投递失败',
      'Return': '包裹退回',
      'Exception': '包裹异常',
      'Delete': '已删除'
    }
    if (statusJson.hasOwnProperty(key)) {
      return statusJson[key]
    } else {
      return ''
    }
  },
  CapitalStatusFormat(key) {
    // 资金流水平盘
    let statusJson = {
      'NoPayment': '不需要支付',
      'Pending': '待支付',
      'Paying': '支付中',
      'StayHandle': '待银行处理',
      'Handleing': '银行处理中',
      'Paid': '已支付',
      'PaymentFailure': '支付失败',
      'BankForcedPayment': '银行强制平盘',
      'Abnormity': '异常中'
    }
    if (statusJson.hasOwnProperty(key)) {
      return statusJson[key]
    } else {
      return ''
    }
  },
  /**
   *  金额不足2位小数，补零
   * **/
  moneyFormat(x, code) {
    var f = parseFloat(x)
    if (isNaN(f)) {
      return ''
    }
    if (x == 0) {
      return 0
    }
    if (code && code === 'JPY') {
      return f.toFixed(0).toString().replace(/\d{1,3}(?=(\d{3})+(?:\.\d{1,2})?$)/g, '$&,')
    }
    var f = Math.round(x * 100) / 100
    var s = f.toString()
    var rs = s.indexOf('.')
    if (rs < 0) {
      rs = s.length
      s += '.'
    }
    while (s.length <= rs + 2) {
      s += '0'
    }
    return s
  },
  /**
   * 日期解析，字符串转日期
   * @param dateString 可以为2017-02-16，2017/02/16，2017.02.16
   * @returns {Date} 返回对应的日期对象
   */
  dateParse(dateString) {
    let SEPARATOR_BAR = '-'
    let SEPARATOR_SLASH = '/'
    let SEPARATOR_DOT = '.'
    let dateArray
    if (dateString !== '' && dateString !== null) {
      if (dateString.indexOf(SEPARATOR_BAR) > -1) {
        dateArray = dateString.split(SEPARATOR_BAR)
      } else if (dateString.indexOf(SEPARATOR_SLASH) > -1) {
        dateArray = dateString.split(SEPARATOR_SLASH)
      } else {
        dateArray = dateString.split(SEPARATOR_DOT)
      }
    }
    return new Date(dateArray[0], dateArray[1] - 1, dateArray[2])
  },
  /**
   * 日期比较大小
   * compareDateString大于dateString，返回1；
   * 等于返回0；
   * compareDateString小于dateString，返回-1
   * @param dateString 日期
   * @param compareDateString 比较的日期
   */
  dateCompare(dateString, compareDateString) {
    if (dateString !== '' && dateString !== null && compareDateString !== '' && compareDateString !== null) {
      let dateTime = this.dateParse(dateString).getTime()
      let compareDateTime = this.dateParse(compareDateString).getTime()
      if (compareDateTime > dateTime) {
        return 1
      } else if (compareDateTime === dateTime) {
        return 0
      } else {
        return -1
      }
    }
  },
  /**
   * 判断日期区间[startDateCompareString,endDateCompareString]是否完全在别的日期区间内[startDateString,endDateString]
   * 即[startDateString,endDateString]区间是否完全包含了[startDateCompareString,endDateCompareString]区间
   * 在区间内返回true，否返回false
   * @param startDateString 新选择的开始日期，如输入框的开始日期
   * @param endDateString 新选择的结束日期，如输入框的结束日期
   * @param startDateCompareString 比较的开始日期
   * @param endDateCompareString 比较的结束日期
   * @returns {Boolean}
   */
  isDatesBetween(startDateString, endDateString, startDateCompareString, endDateCompareString) {
    if (startDateString !== '' && startDateString !== null && endDateString !== '' && endDateString !== null && startDateCompareString !== '' && startDateCompareString !== null && endDateCompareString !== '' && endDateCompareString !== null) {
      let flag = false
      let startFlag = (this.dateCompare(startDateCompareString, startDateString) < 1)
      let endFlag = (this.dateCompare(endDateCompareString, endDateString) > -1)
      if (startFlag && endFlag) {
        flag = true
      }
      return flag
    }
  },
  // 获取地址栏参数 不转码
  getQueryString_:function(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    if (window.location.href.split("?")[1] != undefined) {
      var r = window.location.href.split("?")[1].match(reg);
      if (r == undefined && window.location.href.split("?").length > 2) {
        r = window.location.href.split("?")[2].match(reg);
      }
      if (r != null) return r[2];
      return null;
    }
  },
  delay:(function () {//防抖函数
    let timer = 0
    return function (callback, ms=1000) {
      clearTimeout(timer)
      timer = setTimeout(callback, ms)
    }
  })()

}




// WEBPACK FOOTER //
// ./src/public/common.js